'use client';

import { useState } from 'react';
import { startRegistration } from '../api/start-registration';
import type { StartRegistrationPayload } from './start-registration-payload';
import type { SplitWizardSubmitContextValue, SplitWizardSubmitError } from '@/widgets/registration-wizard/model/split-wizard-submit-context';


export const useStartRegistration = (): SplitWizardSubmitContextValue => {
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ]     = useState<SplitWizardSubmitError | null>(null);

    const submit: SplitWizardSubmitContextValue['submit'] = async (data) => {
        setError(null);

        if (!data.profile || !data.company || !data.credentials) {
            setError({ kind: 'generic', message: 'Profile, company and credentials are required' });
            return null;
        }

        const payload: StartRegistrationPayload = {
            profile    : data.profile,
            company    : data.company,
            credentials: data.credentials,
        };

        setLoading(true);

        try {
            const response = await startRegistration(payload);

            if (!response.ok) {
                if (response.error === 'email_already_registered') {
                    setError({ kind: 'email_exists' });
                }
                else {
                    setError({ kind: 'generic', message: response.error });
                }
                return null;
            }

            return { checkoutUrl: null };
        }
        catch (err) {
            setError({
                kind   : 'generic',
                message: err instanceof Error ? err.message : 'Unexpected error',
            });
            return null;
        }
        finally {
            setLoading(false);
        }
    };

    return { submit, loading, error, setError };
};
